














// Composition
import { defineComponent, computed } from '@nuxtjs/composition-api'

// Components
import FacetBlockAccordion from './FacetBlockAccordion.vue'
import FacetShowButton from './FacetsShowButton.vue'

// Store
import { useSearchStore } from '@/store/search'

// Composables
import useFacets from '@/composables/search/useFacets'

// Common
import { showFacetsArray, nestedFacets, hiddenFacets } from '@/common/static/facets'
import { NESTED_FACET_NAMES } from '@/common/static/search'

// Types
import { FacetInterface, FacetNestedAndHiddenSelectedInterface } from '@/types/search/searchTypes'

export default defineComponent({
  name: 'FacetBlock',

  components: {
    FacetBlockAccordion,
    FacetShowButton,
  },

  props: {
    options: {
      type: Object,
      required: true,
    },
  },

  setup(props) {
    const { existingFacetIndex, facetKeySelected } = useFacets()
    const searchStore = useSearchStore()
    const facetsToCheck = nestedFacets.concat(hiddenFacets)
    const showMoreFilterButton = computed(() => {
      let showValue = false
      const nestedAndHiddenSelected: FacetNestedAndHiddenSelectedInterface = {}

      // check if nested and hidden facets are available
      facetsToCheck.forEach((hiddenFacet) => {
        if (
          hiddenFacet !== undefined &&
          props.options.facetResults?.[hiddenFacet]?.[0]?.data !== undefined &&
          props.options.facetResults?.[hiddenFacet]?.[0]?.data!.length > 0
        ) {
          if (
            props.options.facetResults![hiddenFacet][0].data!.filter(
              (dataObj: FacetInterface) => dataObj.value !== 'false'
            ).length > 0
          ) {
            // the facet is avalailable
            showValue = true

            // check if we have selected one within the hidden and nested facets
            if (nestedFacets.includes(hiddenFacet) && nestedAndHiddenSelected.nested !== true) {
              nestedAndHiddenSelected.nested = facetKeySelected(hiddenFacet)
            }
            if (hiddenFacets.includes(hiddenFacet) && nestedAndHiddenSelected.hidden !== true) {
              nestedAndHiddenSelected.hidden = facetKeySelected(hiddenFacet)
            }
          }
        }
      })

      const nestedAndHiddenSelectedValues = Object.values(nestedAndHiddenSelected)
      if (nestedAndHiddenSelectedValues.length > 0 && nestedAndHiddenSelectedValues.every((v) => v === true)) {
        showValue = false
      }

      return showValue
    })

    const showOther = () => {
      // go over each nestedFacet
      // check if there's data, if not return false
      // if there's data, check if it a true value. Otherwise, return a false
      let showOther = false
      if (nestedFacets === undefined) {
        return false
      }

      nestedFacets.forEach((nestedFacetName: string | undefined) => {
        if (nestedFacetName !== undefined) {
          const nestedFacetResults = props.options.facetResults![nestedFacetName][0].data
          if (
            nestedFacetResults !== undefined &&
            nestedFacetResults.length > 0 &&
            nestedFacetResults.filter((result: FacetInterface) => result.value === 'true').length > 0
          ) {
            showOther = true
          }
        }
      })
      return showOther
    }

    // Determine if we want to show this facet
    const showFacet = (facet: any, key: string) => {
      // Special treatment for other
      if (key === NESTED_FACET_NAMES.other.key && searchStore.ui.showAllFacets === true) {
        return showOther()
      }

      // If this facet is selected, show the box anyway
      if (existingFacetIndex(key.toString()) !== -1) {
        return true
      }

      // if this facet has data and if the data length is higher then 0
      if (facet[0] !== undefined && facet[0].data !== undefined && facet[0].data.length > 0) {
        // If there's data to show, check if the user clicked on 'more filters'
        // if not, check if this facet is a popular facet
        if (searchStore.ui.showAllFacets === false) {
          return showFacetsArray.includes(key)
        } else {
          // if yes, show all facets
          return true
        }
      } else {
        return false
      }
    }

    return {
      existingFacetIndex,
      showFacet,
      showFacetsArray,
      hiddenFacets,
      showMoreFilterButton,
    }
  },
})
